import { getCopilotChatDrawerState } from "../store/store";

export function getShowBizChatInReadingPane(targetWindow: Window): boolean {
    return getCopilotChatDrawerState(targetWindow)?.showInReadingPane ?? false;
}
